<template>
    <v-card class="fill-height">
        <v-card-title primary-title>
            <h3 class="headline">Patients</h3>
            <v-spacer></v-spacer>
            <v-btn right color="primary" :to="{ name: 'patient.quickAdd' }">
                <v-icon>add</v-icon>
                Créer un patient
            </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-layout align-center justify-end row>
                <v-flex xs6>
                    <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Recherche"
                        single-line
                        hide-details>
                    </v-text-field>
                </v-flex>
            </v-layout>
        </v-card-text>

        <v-data-table
            class="mx-4"
            :headers="headers"
            :items="customSearch"
            :pagination.sync="paginator">
            <template v-slot:items="props">
                <router-link tag="tr" :to="{name: 'patient.view', params: { id: props.item.id } }">
                    <td>{{ props.item.lastname }}</td>
                    <td>{{ props.item.firstname }}</td>
                    <td>{{ props.item.email }}</td>
                    <td>{{ props.item.opale_number }}</td>
                    <td>{{ props.item.last_updated }}</td>
                    <td :style="'color: ' + getColorForNextFollowUpDate(props.item.next_follow_up_date)"
                    >
                        {{ formatDate(props.item.next_follow_up_date) }}
                    </td>
                </router-link>
            </template>
            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                    Aucun résultat pour "{{ search }}".
                </v-alert>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import moment from "moment";

export default {
    name: "UserList",
    computed: mapState({
        patients: state => state.patients.all,
        customSearch() {
            let searched = this.search.toLowerCase().split(' ');
            return this.patients.filter(patient => {
                const firstName = patient.firstname.toLowerCase();
                const lastName = patient.lastname.toLowerCase();
                const fullName = `${firstName} ${lastName}`;

                return searched.every(search => {
                    return fullName.includes(search);
                });
            });
        }
    }),
    data() {
        return {
            has_error: false,
            search: '',
            headers: [
                {text: 'Nom', align: 'left', value: 'lastname'},
                {text: 'Prénom', value: 'firstname'},
                {text: 'Email', value: 'email'},
                {text: 'N°Opale', value: 'opale_number'},
                {text: 'Date', value: 'last_updated'},
                {text: 'Prochain suivi', value: 'next_follow_up_date'},
            ],
            paginatorText: "Résultats par page",
            paginator: {
                rowsPerPage: 25,
                sortBy: 'lastname',
                //descending:true
            }
        }
    },

    mounted() {
        this.getAllPatients()
    },
    methods: {
        ...mapActions('patients', [
            'getAllPatients'
        ]),


        formatDate(date) {
          if (!date) return null
          return moment(date).format('DD/MM/YYYY')
        },

        getColorForNextFollowUpDate(date) {
            if (!date) return

            if(moment(date).isBefore(moment())) {
                return 'red'
            }
            //mettre en vert si diff date < 3 semaines
            if(moment(date).isBefore(moment().add(3, 'weeks'))){
                return 'green'
            }

            return 'black'
        }
    }
}
</script>
